import script from "./map-type.vue?vue&type=script&setup=true&lang=js"
export * from "./map-type.vue?vue&type=script&setup=true&lang=js"

import "./map-type.vue?vue&type=style&index=0&id=0506f342&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/map/tools/map-type.vue'],['__file',"map-type.vue"]])

export default __exports__